<template>
  <div class="data-control">
    <!-- ---头部--- -->
    <content-title title="数据内部质量控制和质量保证相关规定" />
    <!-- ---说明--- -->
    <write-instruction :instructionsList="instructionsList" />
    <Input show-word-limit v-model="detail" type="textarea" :rows="20" :disabled="editOrView == 'view'" />
    <!-- ---底部按钮组--- -->
    <save-next v-if="editOrView == 'edit'" :btnLoading="btnLoading" @on-save="handleOk('save')" @go-next="nextPage" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";
import writeInstruction from "@/components/comment/write-instruction.vue";
import saveNext from "@/components/comment/save-next.vue";

import {qualityControlDetail,qualityControlSave} from "@/api/monitoring-plan";


export default {
  name: "dataControl",
  components: { contentTitle, writeInstruction, saveNext, },
  data () {
    return {
      btnLoading: {
        saveUnit: false,
        nextPage: false
      },
      instructionsList: ["1、至少包括《企业温室气体排放核算方法与报告指南》标准要求的内容。"],
      detail: "",
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editOrView () {
      return this.getUserInfo.user.editOrView;
    },
    planId () {
      return this.getUserInfo.user.planId;
    },
  },
  created () {
    this.getData();
  },
  methods: {
    async getData () {
      await qualityControlDetail({ planId: this.planId }).then((res) => {
        this.detail = res.body.detail;
      });
    },
    handleOk (type) {
      if (this.detail.length > 3000) {
        this.$Message.error("最大输入字符长度为3000");
      } else {
        this.save(type);
        this.$Message.success("保存成功");
      }
    },
    save (type) {
      if (type === 'save') {
        this.btnLoading.saveUnit = true
      } else if (type === 'next') {
        this.btnLoading.nextPage = true
      }
      let params = {
        planId: this.planId,
        detail: this.detail,
      };
      qualityControlSave(params).then(async (res) => {
        if (type === 'save') {
          await this.getData();
          this.btnLoading.saveUnit = false
        } else if (type === 'next') {
          this.btnLoading.nextPage = false
        }
      });
    },
    async nextPage () {
      if (this.detail.length > 3000) {
        this.$Message.error("最大输入字符长度为3000");
      } else {
        await this.save('next');
        this.$router.push({ path: "/plan/plan-9" });
      }
    },
  },
};
</script>

<style lang="less" scoped>
</style>